import React, { memo } from 'react';
import Icon from 'components/Shared/Common/Icon';

const FileSliderThumbItem = () => <Icon iconName="ZipFile" />;

export default memo(FileSliderThumbItem);
